import { render } from "./MyYoutube.vue?vue&type=template&id=20069e39&scoped=true"
import script from "./MyYoutube.vue?vue&type=script&lang=js"
export * from "./MyYoutube.vue?vue&type=script&lang=js"

import "./MyYoutube.vue?vue&type=style&index=0&id=20069e39&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20069e39"]])

export default __exports__